module.exports = __webpack_public_path__ + "static/kartchen_info-596cdddd5c8f98cf7cc3dd7173160ef5.png";